import { Wave } from 'better-react-spinkit'
import { collection, deleteDoc, doc, getDocs, limit, orderBy, query, startAfter, where } from 'firebase/firestore'
import React, { useContext, useEffect, useState } from 'react'
import { BsFilterSquareFill } from 'react-icons/bs'
import { MdClose } from 'react-icons/md'
import { AuthContext } from '../../authContext/AuthContext'
import { db } from '../../firebase'
import Navbar from '../navbar/Navbar'
import Sidebar from '../sidebar/Sidebar'
import Row from './Row'

const EmployeesStats = () => {
    const { currentUser } = useContext(AuthContext)
    const [stats, setStats] = useState([])
    const [selectedId, setSelectedId] = useState('')
    const [timeStamp, setTimeStamp] = useState('')
    const [lastVisibles, setLastVisibles] = useState({})
    const [isEmpty, setIsEmpty] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        async function getStats() {
            setIsLoading(true)
            setIsEmpty(false)
            setStats([])
            const q = !timeStamp ? query(collection(db, 'machine_job_stats'), where('adminId', '==', currentUser.uid), orderBy('timestamp', 'desc'), limit(8)) :
                query(collection(db, 'machine_job_stats'), where('adminId', '==', currentUser.uid), where('timestamp', '>=', timeStamp), orderBy('timestamp', 'asc'), limit(8))
            const snapshot = await getDocs(q)
            if (!snapshot.empty) {
                setLastVisibles(snapshot.docs[snapshot.docs.length - 1])
                const data = []
                snapshot.forEach((doc) => {
                    data.push({ ...doc.data(), id: doc.id })
                })
                setStats(data)
            } else {
                setIsEmpty(true)
            }
            setIsLoading(false)
        }
        getStats()
    }, [timeStamp, currentUser])

    const handleNext = async () => {
        setIsLoading(true)
        const next = !timeStamp ?
            query(collection(db, "machine_job_stats"),
                where('adminId', '==', currentUser.uid),
                orderBy("timestamp", 'desc'),
                startAfter(lastVisibles),
                limit(8)) : query(
                    collection(db, "machine_job_stats"),
                    where('adminId', '==', currentUser.uid),
                    where('timestamp', '>=', timeStamp),
                    orderBy("timestamp", 'asc'),
                    startAfter(lastVisibles),
                    limit(8))

        const snap = await getDocs(next)
        const newdata = []
        if (!snap.empty) {
            snap?.forEach((doc) => {
                newdata.push({
                    ...doc.data(),
                    id: doc.id
                })
            })
            setStats(prev => [...prev, ...newdata])
            setLastVisibles(snap.docs[snap.docs.length - 1])
        } else {
            setIsEmpty(true)
        }
        setIsLoading(false)
    }

    async function deleteStat() {
        await deleteDoc(doc(db, 'machine_job_stats', selectedId))
        setStats(prev => prev.filter(s => s.id !== selectedId))
        setSelectedId('')
    }

    return (
        <div>
            <Navbar />
            <div className="flex bg-gray-100">
                <Sidebar currentPage='Employees Stats' />
                <div className="flex-1 flex h-[calc(100vh-50px)] overflow-hidden justify-center items-center">
                    <div className="w-[98%] mx-2 shadow-md bg-white rounded-xl h-[96%] flex flex-col">
                        <header className="w-full h-16 border-b-[1px] px-2 py-4 sm:px-3 border-slate-300 flex justify-between items-center">
                            <h1 className='font-bold text-xl box-border text-slate-600'>Employees Stats</h1>
                            <div className="flex">
                                <div className='group relative cursor-pointer'>
                                    <BsFilterSquareFill className='text-5xl text-gray-600 cursor-pointer p-2' />
                                    <div className="hidden group-hover:block absolute top-9 right-0 bg-gray-50 px-3 py-2 z-50 rounded-md shadow-lg">
                                        <p className='text-gray-600 font-medium mt-1 mb-2 text-md font-serif'>Select Date</p>
                                        <input onChange={(e) => {
                                            setTimeStamp(new Date(e.target.value))
                                        }} id='datatimepicker' className='px-2 py-1 mb-2 rounded-md outline-none' type="date" />
                                        {timeStamp !== '' && <button onClick={() => setTimeStamp('')} className='mt-2 px-4 py-1 bg-red-200 text-gray-800 rounded-md active:bg-red-300 font-medium'>Clear</button>}
                                    </div>
                                </div>
                            </div>
                        </header>
                        <div className="flex-1 overflow-x-auto">
                            <div className="relative mt-1 p-1">
                                <table className="sm:rounded-lg w-full box-border min-w-[1000px] text-sm text-left text-gray-500 dark:text-gray-400 rounded-xl overflow-hidden">
                                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-200 dark:text-gray-600">
                                        <tr>
                                            <th scope="col" className="px-6 py-3">
                                                Name
                                            </th>
                                            <th scope="col" className="px-6 py-3">
                                                File Name
                                            </th>
                                            <th scope="col" className="px-6 py-3">
                                                Work Started At
                                            </th>
                                            <th scope="col" className="px-6 py-3">
                                                Work Stopped At
                                            </th>
                                            <th scope="col" className="px-6 py-3">
                                                Total Time
                                            </th>
                                            <th scope="col" className="px-6 py-3">
                                                Round
                                            </th>
                                            <th scope="col" className="px-6 py-3">
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stats.map((doc, i) => (
                                            <Row key={doc.id} doc={doc} index={i + 1} setSelectedId={setSelectedId} />
                                        ))}
                                    </tbody>
                                </table>
                                <div className='flex justify-center my-3'>

                                    {isEmpty && <span className='text-gray-600 font-thin'>No more results</span>}
                                    {isLoading ? <Wave color='gray' size={35} /> : !isEmpty && <button className='px-4 py-2 bg-gray-100 rounded-xl font-medium text-gray-600 active:bg-slate-300' onClick={handleNext}>Show more</button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {selectedId !== '' ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                    >
                        <div className="relative w-auto my-6 mx-auto max-w-3xl">
                            <div className="border-0 rounded-lg shadow-lg relative flex flex-col max-h-[84vh] w-[100vw] sm:w-[360px] bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div className="flex items-center justify-between px-3 py-3 border-b border-solid border-slate-200 rounded-t">
                                    <h5 className="text-xl font-semibold">
                                        Are you sure you want to delete?
                                    </h5>
                                    <MdClose className='text-2xl cursor-pointer font-bold text-black' onClick={() => { setSelectedId('') }} />
                                </div>
                                {/*body*/}

                                {/*footer*/}
                                <div className="flex items-center justify-end p-2 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        className="bg-blue-500 flex items-center justify-center disabled:bg-gray-400 text-white active:bg-blue-600 font-bold uppercase text-sm px-6 py-2 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={deleteStat}
                                    >
                                        Yes
                                    </button>
                                    <button
                                        className="modal-close-btn"
                                        type="button"
                                        onClick={() => { setSelectedId('') }}
                                    >
                                        No
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </div>
    )
}

export default EmployeesStats
